import { Injectable } from '@angular/core';
import File from 'src/app/models/File';

import APIService from '../api.service';

type ArticleFilesResponse = {
    files?: File[];
    file: File;
    isFile?: boolean;
};

@Injectable({
    providedIn: 'root',
})
export class FileManagerService {
    constructor(private api: APIService) {}

    getArticleFiles(
        article_id: string,
        path: string[] = []
    ): Promise<ArticleFilesResponse | null> {
        return new Promise(resolve => {
            this.api
                .get(`/workers/articles/files/`, {
                    article_id,
                    path: path.join('<>'),
                })
                .then((res: any) => {
                    const { success } = res;
                    if (!success) return resolve(null);

                    const { data } = res;
                    return resolve(data);
                })
                .catch(err => {
                    this.log(err);
                    return resolve(null);
                });
        });
    }

    getServePath() {
        return this.api.base_url + '/workers/articles/files/serve/';
    }

    /**
     * La URL de un fichero a partir de su firma.
     *
     * `mini` es la miniatura de la rejilla, `ver` el original para el visor y
     * `descarga` el fichero con `Content-Disposition: attachment`.
     *
     * No lleva cabecera de autorización a propósito: la credencial va en la
     * URL porque un `<img src>` no puede mandar cabeceras. Además eso la deja
     * como petición simple de CORS, sin `preflight`, que sobre la red del
     * taller es una ida y vuelta menos por cada miniatura.
     */
    getMediaUrl(modo: 'mini' | 'ver' | 'descarga', firma: string, ancho?: number) {
        const base = `${this.api.base_url}/workers/articles/files/media/${modo}/${encodeURIComponent(
            firma
        )}`;

        return ancho ? `${base}?w=${ancho}` : base;
    }

    uploadImageCapture(
        article_id: string,
        path: string[] = [],
        image_title: string,
        image_description: string,
        image_data: string
    ): Promise<ArticleFilesResponse | null> {
        return new Promise(resolve => {
            this.api
                .post(`/workers/articles/files/upload/`, {
                    article_id,
                    path: path.join('<>'),
                    image_title,
                    image_description,
                    image_data
                })
                .then((res: any) => {
                    const { success } = res;
                    if (!success) return resolve(null);

                    const { data } = res;
                    return resolve(data);
                })
                .catch(err => {
                    this.log(err);
                    return resolve(null);
                });
        });
    }

    log(...args: any[]) {
        console.debug('[FileManagerService]', ...args);
    }
}

export default FileManagerService;
